import { useEffect, useState } from "react";
import { Search, X } from "lucide-react";
import { useDebounced } from "@/lib/use-debounce";

export function UrlSearch({
  value,
  onChange,
}: {
  value: string;
  onChange: (next: string) => void;
}) {
  const [draft, setDraft] = useState(value);
  const debounced = useDebounced(draft, 300);

  useEffect(() => { setDraft(value); }, [value]);
  useEffect(() => {
    if (debounced !== value) onChange(debounced);
  }, [debounced]);  // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="relative">
      <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-muted pointer-events-none" />
      <input
        className="input pl-8 pr-7 w-72"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        placeholder="URL prefix (^example is implied)"
      />
      {draft ? (
        <button
          type="button"
          className="absolute right-1 top-1/2 -translate-y-1/2 p-1 text-muted hover:text-fg"
          onClick={() => setDraft("")}
          aria-label="Clear search"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      ) : null}
    </div>
  );
}
